<template>
    <iframe
        :id="documentsFrameID"
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        :src="documentsFrameUrl"
        @load="documentsFrameLoaded"
    ></iframe>
</template>

<script>
    export default {
        name: 'OwnerDocumentsFrame',
        props: {
            ownerId: Number,
        },
        computed: {
            documentsFrameUrl() {
                return `/app/owner/owner/${this.ownerId}/documents-frame/`;
            },
        },
        data() {
            return {
                documentsFrameID: 'owner-documents-iframe',
            }
        },
        methods: {
            documentsFrameLoaded() {
                this.$emit('load');
            }
        }
    }
</script>
